export const FETCH_NETWORKS = 'FETCH_NETWORKS'

export const fetchNetworks = networkData => ({
    type: FETCH_NETWORKS,
    payload: networkData
})
